import React from "react";
import { Badge } from "reactstrap";

const BetaBadge = () => (
  <Badge color="primary">beta</Badge>
);

export default BetaBadge;
